import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private title: Title, private meta: Meta,
    private localStorage: LocalStorageService

    ) {}

  updateTitle(title: string) {
    const lang = this.localStorage.get('lang')
    lang == 'en' ? this.title.setTitle(`Amanda - ${title}`) : this.title.setTitle(`اماندا - ${title}`);
  }

  updateOgTitle(title: string) {
    this.meta.updateTag({ property: 'og:title', content: title });
  }
  updateOgDescription(desc: string) {
    this.meta.updateTag({ property: 'og:description', content: desc });
  }
}
